const container = document.querySelector(".container");
const gradientText = document.querySelector(".subtitle-link");
const maxRotation = 60;
container.addEventListener("mousemove", (e)=>{
    const rect = container.getBoundingClientRect();
    const x = (e.clientX - rect.left) / rect.width;
    // Calculate the background position based on cursor's x-coordinate
    const backgroundPos = 100 - x * 100;
    gradientText.style.backgroundPosition = `${backgroundPos}% 50%`;
});
container.addEventListener("mouseleave", ()=>{
    gradientText.style.backgroundPosition = "100% 50%";
});

//# sourceMappingURL=index.71009f8a.js.map
